<template>
  <div class="qrcode" v-if="bShow">
    <div class="content-wrapper">
      <div class="head">
        <img class="close" @click="hide" src="./close.png" alt="close" width="20" height="20">
        <span class="title">{{$t(title)}}</span>
      </div>
      <img :src="url" alt="QRcode" width="300" height="300">
      <p class="explain">{{classinfo? '微信扫一扫，进入页面后，点击右上角分享给学生注册报名': $t('m.wechat_share')}}</p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    props: {
      title: {
        type: String
      },
      schoolinfo: {
        type: Object
      },
      lessoninfo: {
        type: Object
      },
      classinfo: {
        type: Object
      }
    },
    data(){
      return {
        id: (() => {
          return loadLocal('id', false);
        })(),
        imgprefix: (() => {
          return loadLocal('imgprefix', false);
        })(),
        bShow: false,
        url: '',
        testUrl:'',
      }
    },
    methods: {
      show() {
        this.url = '';
        this.getShareUrl();
        this.bShow = true;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'hidden';
      },
      hide(){
        this.bShow = false;
        let oBody = document.getElementsByTagName('body')[0];
        oBody.style.overflow = 'auto';
      },
      cutIntroduce(introduce){
        if (introduce === '') {
          return ''
        } else {
          let list = JSON.parse(decodeURIComponent(introduce));
          for (let i = 0; i < list.length; i++) {
            if (!list[i].isImage && list[i].text !== '') {
              if (list[i].text.length > 50) {
                return list[i].text.substring(0, 50).replace(/\s/g, '')+'...';
              }
              return list[i].text.replace(/\s/g, '');
            }
          }
        }
        return '';
      },
      getShareUrl(){
        //如果lessoninfo为undefined，则证明没有传入lessonid，为请求分享网校
        if (this.lessoninfo === undefined) {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'room',
              a: 'GetRoomShareUrl',
              rid: this.schoolinfo.rid,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 200) {
              this.testUrl=response.url;
              let url = encodeURIComponent(response.url);
              url = encodeURIComponent(url);
              let title = `${decodeURIComponent(this.schoolinfo.roomname)}`;
              let subtitle = this.cutIntroduce(this.schoolinfo.introduce)||response.sharecontent;
              let img = response.imgprefix + this.schoolinfo.faceimg || response.shareimage;
              let finalUrl = response.homepath + `indexm.html#/share?title=${title}&subtitle=${subtitle}&img=${img}&url=${url}`;
              finalUrl = encodeURIComponent(finalUrl);
              this.url = response.path + 'indexapp.php?c=QRCode&a=QRCode&url=' + finalUrl + '&size=6';
            }
          }).catch((err) => {
            console.log(err);
          });
        }
        //如果班级信息为undefined，则是分享课程
        else if (this.classinfo === undefined) {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'Lesson',
              a: 'GetLessonShareUrl',
              rid: this.schoolinfo.rid,
              lessonid: this.lessoninfo.id,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 200) {
              let url = encodeURIComponent(response.url);
              url = encodeURIComponent(url);
              // let title = `${decodeURIComponent(this.lessoninfo.lessonname)}`;
              let title = `${encodeURIComponent(this.lessoninfo.lessonname)}`;
              let subtitle = this.cutIntroduce(this.lessoninfo.introduce)||response.sharecontent;
              subtitle=encodeURIComponent(subtitle);
              subtitle=encodeURIComponent(subtitle);
              let img = response.imgprefix + this.lessoninfo.faceimg || response.shareimage;
              let finalUrl = response.homepath + `/mstudent/index.html#/share?title=${title}&subtitle=${subtitle}&img=${img}&url=${url}`;
              finalUrl = encodeURIComponent(finalUrl);
              this.url = response.path + 'indexapp.php?c=QRCode&a=QRCode&url=' + finalUrl + '&size=6';
            }
          }).catch((err) => {

          });
        }
        else {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'Lesson',
              a: 'GetClassShareUrl',
              rid: this.schoolinfo.rid,
              lessonid: this.lessoninfo.id,
              classid: this.classinfo.id,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 200) {
              let url = encodeURIComponent(response.url);
              url = encodeURIComponent(url);
              let title = `${decodeURIComponent(this.classinfo.classname)}`;
              let subtitle = this.cutIntroduce(this.classinfo.introduce)||response.sharecontent;
              let img =response.imgprefix +  this.lessoninfo.faceimg || response.shareimage;
              let finalUrl = response.homepath + `/mstudent/index.html#/share?title=${title}&subtitle=${subtitle}&img=${img}&url=${url}`;
              finalUrl = encodeURIComponent(finalUrl);
              this.url = response.path + 'indexapp.php?c=QRCode&a=QRCode&url=' + finalUrl + '&size=6';
            }
          }).catch((err) => {
            console.log(err);
            // this.getShareUrl();
          });
        }

      }

    },
    created(){

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .qrcode
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    display: flex
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    overflow: auto
    .content-wrapper
      margin: auto
      width: 420px
      padding: 30px 60px 40px
      border-radius: 4px
      background: #ffffff
      font-size: 0
      box-sizing border-box
      position relative
      .close
        position absolute
        top: 20px
        right: 20px
        cursor: pointer
      .title
        line-height: 32px
        font-size: 24px
        color: #000
        font-weight: bold
      .explain
        font-size: 14px
        color: #333
        line-height: 18px


</style>



// WEBPACK FOOTER //
// src/components/shareschoolpage/ShareSchoolPage.vue